import utils from './utils'
import validator from './validator'

const initFormParam = obj => {
  return utils.getSearchParams(obj.Type || '')
}

const initFormItem = (obj, form, param) => {
  switch(param.componentId) {
    case 'select':
      if(param.trueValue) {
        form[`select_${obj.Key}`] = obj.Value || ''
        form[obj.Key] = obj.Value = ''
      } else {
        form[obj.Key] = obj.Value || ''
      }
      break;
    default:
      form[obj.Key] = obj.Value || ''
      break;
  }
}

const initFormRules = (obj, $vm, param, noisy = {}) => {
  let rules = []

  rules.push(validator.required(obj, param, $vm))

  if(obj.Rules !== undefined) {
    obj.Rules.forEach((rule) => {
      let [type, ...args] = rule
      switch(type) {
        case 'totalValidWithNumber':
          utils.anoyFunction(() => {
            let [total, keys, message] = args
            rules.push(validator.totalValidWithNumber($vm, total, keys, message))
          })
          break;
        case 'totalValidWithKey':
          utils.anoyFunction(() => {
            let [key, keys, message] = args
            rules.push(validator.totalValidWithKey($vm, key, keys, message))
          })
          break;
        case 'numberValidWithDecimal':
          utils.anoyFunction(() => {
            let [decLength, spValues, excludeZero] = args
            rules.push(validator.numberValidWithDecimal(decLength, spValues, excludeZero))
          })
          break;
        case 'numberValidWithMaxDecimal':
          utils.anoyFunction(() => {
            let [decLength, spValues, excludeZero] = args
            rules.push(validator.numberValidWithMaxDecimal(decLength, spValues, excludeZero))
          })
          break;
        case 'validNumberRange':
          utils.anoyFunction(() => {
            let [[min, max], message] = args
            rules.push(validator.numberRange(min, max, message))
          });
          break;
        case 'patternValid':
          utils.anoyFunction(() => {
            let [pattern] = args
            rules.push(validator.patternValid(obj, pattern))
          });
          break;
        case 'idCardNoValid':
          utils.anoyFunction(() => {
            rules.push(validator.idCardNoValid(obj))
          });
          break;
        case 'orgCode':
          utils.anoyFunction(() => {
            rules.push(validator.orgCode(obj))
          });
          break;
        case 'societyCode':
          utils.anoyFunction(() => {
            rules.push(validator.societyCode(obj))
          });
          break;
        case 'orgOrSociety':
          utils.anoyFunction(() => {
            let [isStrict] = args
            rules.push(validator.orgOrSociety(obj, isStrict))
          });
          break;
        case 'patternCustom': 
          utils.anoyFunction(() => {
            let [pattern, message] = args
            rules.push(validator.patternCustom(obj, pattern, message))
          });
          break;
        case 'limitTextLength': 
          utils.anoyFunction(() => {
            let [[min, max]] = args
            rules.push(validator.limitTextLength(obj, min, max))
          });
          break;
        case 'customValidator': 
          utils.anoyFunction(() => {
            let [trigger = 'change', ...elseArgs] = args
            rules.push(validator.customValidator(obj, $vm, trigger, elseArgs))
          });
          break;
        case 'houseRules': 
          utils.anoyFunction(() => {
            let [trigger = 'change', ...elseArgs] = args
            rules.push(validator.houseRules(obj, $vm, trigger, elseArgs, noisy))
          });
          break;
        case 'trafficRules': 
          utils.anoyFunction(() => {
            let [trigger = 'change', ...elseArgs] = args
            rules.push(validator.trafficRules(obj, $vm, trigger, elseArgs, noisy))
          });
          break;
      }
    })
  }
  return rules
}

export default {
  initFormParam,
  initFormItem,
  initFormRules
}